function convertDateToTimeLocal(date) {
    if (typeof date == 'undefined') {
        return null;
    }
    let dateTimeLocal = new Date(date);
    return dateTimeLocal;
}